import { GenericServiceRequest } from './generic-service-request';
import { FindOptions } from '../domain-models/find-options/find-options';
import { AutoCompleteOptions } from '../domain-models/autocomplete/auto-complete-options';

export class AutoCompleteRequest extends GenericServiceRequest<AutoCompleteOptions> {

}
